import { LoadingBox } from "component/basic/popup";
import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const NavigationPage = () => {
    const navigate = useNavigate();
    const param = useParams();
    const type = param.type;

    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(true);

    let isPage = true;
 
    function is_ios(){
        let userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return true;
        }else{
            return false;
        }
    }

    function storeUrl(){
        let isIos = is_ios();
        let url = "";
        
        if(type === "naver"){
            if(isIos){
                url = "http://itunes.apple.com/app/id311867728?mt=8";
            }else{
                url = "https://play.google.com/store/apps/details?id=com.nhn.android.nmap";
            }
        }else if(type === "tmap"){
            if(isIos){
                url = "https://apps.apple.com/kr/app/%ED%8B%B0%EB%A7%B5-%EB%8C%80%EC%A4%91%EA%B5%90%ED%86%B5-%EB%8C%80%EB%A6%AC%EC%9A%B4%EC%A0%84-%EC%A3%BC%EC%B0%A8-%EB%A0%8C%ED%84%B0%EC%B9%B4-%EA%B3%B5%ED%95%AD%EB%B2%84%EC%8A%A4/id431589174";
            }else{
                url = "https://play.google.com/store/search?q=%ED%8B%B0%EB%A7%B5&c=apps&hl=ko";
            }
        }

        return url;
    }

    function appFunc(url){
        let isIos = is_ios();
        let now = new Date().valueOf();
        let userAgent = navigator.userAgent.toLowerCase();
        
        if(isIos && userAgent.indexOf("safari") == -1){
            setTimeout(function(){
                if(new Date().valueOf() - now > 100) return;
                if(isIos){
                    window.location.href = storeUrl();
                }
            }, 50);
        }
        
        window.location.href = url;
        
        if(((isIos && userAgent.indexOf("safari") > -1) || type === "naver") && isPage){
            setTimeout(function(){
                if(isPage) window.location.href = storeUrl();
            }, 3000);
        }
    }

    function appUrl(){
        let appUrlText = "";
        let isIos = is_ios();

        if(process.env.REACT_APP_RENT_ADDR){
            let geocoder = new window.kakao.maps.services.Geocoder();

            geocoder.addressSearch(process.env.REACT_APP_RENT_ADDR, function(result, status){
                if(status === window.kakao.maps.services.Status.OK){
                    if(type === "naver"){
                        appUrlText = `nmap://navigation?dlat=${result[0].y}&dlng=${result[0].x}&dname=${result[0]?.road_address?.building_name||process.env.REACT_APP_RENT_ADDR}&appname=${process.env.REACT_APP_NAVER_APPNAME}`;
                        appFunc(appUrlText);
                    }

                    if(type === "tmap"){
                        appUrlText = `https://apis.openapi.sk.com/tmap/app/routes?appKey=${process.env.REACT_APP_TMAP_KEY}&name=${result[0]?.road_address?.building_name||process.env.REACT_APP_RENT_ADDR}&lon=${result[0].x}&lat=${result[0].y}`;
                        appFunc(appUrlText);
                    }
                }
            });
        }
    }

    useEffect(() => {
        window.onfocus = function(){
            isPage = true;
        };

        setTimeout(() => {
            appUrl();
        }, 100);
    }, []);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === "hidden") {
                isPage = false;
                setTimeout(() => {
                    navigate(-1);
                    localStorage.setItem("popup", "addr")
                }, 100);
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    return (
        <LoadingBox openType={loadingBoxOpen}/>
    );
};

export default NavigationPage;